import attack from '../../../request/request'
import { BASIC, UCENTER } from '../../requers_variable'
export default {
  /**
   * 获取用户列表
   * 
   * @returns 
   */
  get_user(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/member/search`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 添加新户
   */
  add_member(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/member/add`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 移除新户
   */
  remove_member(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/member/remove`,
        data: params,
        success(rep) {
          resolve({
            status: true
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 移交权限
   */
  devolved_member(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/member/devolved`,
        data: params,
        success(rep) {
          resolve({
            status: true
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 退出机构
   */
  quit_member(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/subject/member/quit`,
        data: params,
        success(rep) {
          resolve({
            status: true
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
    /**
   * 账户查询 (模糊查询)
   * 
   * @param {any} params 
   * @returns 
   */
  search(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${UCENTER}/user/search`,
        data: params,
        success(rep) {
          resolve(rep.data)
        },
        error(err) {
          resolve(false)
        }
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/data/basic/plan/usermember.js